export default __webpack_public_path__ + "static/media/refresh.634bc46e.svg";